import { IconVolume } from '@tabler/icons-react';
import { ANNOUNCEMENT_TYPES } from 'constants';
import { useEffect, useState } from 'react';
import { API } from 'utils/api';
import { showError } from 'utils/common';
const useNotice = () => {
  const NOTICE_HEIGHT = 22;
  const [notice, setNotice] = useState('');
  const [noticeType, setNoticeType] = useState('');
  const [noticeHeight, setNoticeHeight] = useState(NOTICE_HEIGHT);
  const [noticeIcon, setNoticeIcon] = useState(<IconVolume stroke={1.5} size="1rem" />);
  const hideNoticeHeight = () => setNoticeHeight(0);
  const showNoticeHeight = () => setNoticeHeight(NOTICE_HEIGHT);
  const getNoticeTitle = (type) => {
    return ANNOUNCEMENT_TYPES.find((e) => e.value == type)?.type || ANNOUNCEMENT_TYPES[0]?.type;
  };
  const getNoticeIcon = (type) => {
    return ANNOUNCEMENT_TYPES.find((e) => e.value == type)?.icon || ANNOUNCEMENT_TYPES[0]?.icon;
  };
  const getOptions = async () => {
    const res = await API.get('/api/notice/');
    const { success, message, data, type, status } = res.data;
    if (success) {
      setNoticeHeight(status == 'true' && !!data ? 22 : 0);
      setNotice(data);
      setNoticeType(getNoticeTitle(type));
      setNoticeIcon(getNoticeIcon(type));
    } else {
      showError(message);
    }
  };
  useEffect(() => {
    getOptions().then();
  }, []);
  return { notice, noticeType, noticeIcon, noticeHeight, hideNoticeHeight, showNoticeHeight };
};
export default useNotice;
